import {fetch} from '..';
import {QueryMethod} from '../utils';
import {RefreshTokenDto} from './dto';

export async function confirmEmail(id: string, code: string) {
  return await fetch('/v1/auth/approve-pending-email', QueryMethod.POST, {
    code,
    id
  });
}

export async function refreshTokenRequest(): Promise<RefreshTokenDto> {
  return await fetch<RefreshTokenDto>(
      '/v1/auth/refresh-access-token',
      QueryMethod.POST,
  );
}

export function forgotPassword(email: string) {
  return fetch('/v1/auth/forgot-password', QueryMethod.POST, { email });
}

